import React from "react";
import { useT } from "@/context/LangContext";

const Flag = ({ code, className = "" }) => {
  if (code === "fr") {
    return (
      <svg viewBox="0 0 3 2" className={className} aria-hidden="true">
        <rect width="1" height="2" x="0" fill="#0055A4" />
        <rect width="1" height="2" x="1" fill="#FFFFFF" />
        <rect width="1" height="2" x="2" fill="#EF4135" />
      </svg>
    );
  }
  // nl
  return (
    <svg viewBox="0 0 3 2" className={className} aria-hidden="true">
      <rect width="3" height="0.667" y="0" fill="#AE1C28" />
      <rect width="3" height="0.667" y="0.667" fill="#FFFFFF" />
      <rect width="3" height="0.667" y="1.333" fill="#21468B" />
    </svg>
  );
};

export default function LanguageSwitcher({ tone = "light" }) {
  const { lang, setLang } = useT();
  const base = tone === "dark" ? "text-white/70" : "text-navy-900/70";
  const activeClass = tone === "dark"
    ? "bg-white/10 text-white border-white/20"
    : "bg-navy-900 text-white border-navy-900";

  return (
    <div className={`inline-flex items-center gap-0.5 rounded-full border ${tone === "dark" ? "border-white/15" : "border-navy-900/10"} p-0.5`} data-testid="lang-switcher">
      {["fr", "nl"].map((code) => {
        const isActive = lang === code;
        return (
          <button
            key={code}
            onClick={() => setLang(code)}
            data-testid={`lang-btn-${code}`}
            className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wider transition ${
              isActive ? `${activeClass} border` : `${base} hover:text-navy-900`
            }`}
          >
            <Flag code={code} className="w-4 h-[10px] rounded-[1px] overflow-hidden shrink-0 shadow-[0_0_0_0.5px_rgba(0,0,0,0.1)]" />
            {code.toUpperCase()}
          </button>
        );
      })}
    </div>
  );
}
